var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { typographyClasses } from '@mui/material/Typography';
import baseTheme from '../baseTheme';
export var MuiTypography = {
    // there's a lot of correctives in here for Overpass not measuring
    // the font space from the baseline (it seems like it uses descender instead...)
    root: {
        marginBottom: '-0.4em',
    },
    gutterBottom: {
        marginBottom: '-0.05em',
    },
    h1: (_a = {
            color: baseTheme.palette.primary.main,
            marginBottom: '-0.3em'
        },
        _a["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + ")",
        },
        _a),
    h2: (_b = {
            marginBottom: '-0.3em'
        },
        _b["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + ")",
        },
        _b),
    h3: (_c = {
            marginBottom: '-0.3em'
        },
        _c["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + ")",
        },
        _c),
    h4: (_d = {
            color: baseTheme.palette.primary.main,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: '-0.3em'
        },
        _d["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.3em + " + baseTheme.spacing(3) + ")",
        },
        _d),
    h5: (_e = {
            marginBottom: '-0.6em'
        },
        _e["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + ")",
        },
        _e),
    subtitle1: (_f = {
            marginBottom: '-0.7em'
        },
        _f["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.7em + " + baseTheme.spacing(3) + ")",
        },
        _f),
    subtitle2: (_g = {
            marginBottom: '-0.6em'
        },
        _g["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + ")",
        },
        _g),
    h6: (_h = {
            marginBottom: '-0.7em'
        },
        _h["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.7em + " + baseTheme.spacing(3) + ")",
        },
        _h),
    body1: (_j = {
            marginBottom: '-0.6em'
        },
        _j["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + ")",
        },
        _j),
    body2: (_k = {
            marginBottom: '-0.75em'
        },
        _k["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.75em + " + baseTheme.spacing(3) + ")",
        },
        _k),
    caption: (_l = {
            fontStyle: 'italic',
            color: baseTheme.palette.text.secondary,
            marginBottom: '-0.6em'
        },
        _l["&." + typographyClasses.gutterBottom] = {
            marginBottom: "calc(-0.6em + " + baseTheme.spacing(3) + ")",
        },
        _l),
};
//# sourceMappingURL=MuiTypography.js.map